import { checkIsBirdviewNormalState } from '../DashboardBirdview.utils.sections'

export function checkHasDashboardTileDelta({ delta, state }) {
  return Boolean(delta) && checkIsBirdviewNormalState(state)
}
